import React from "react";
import ttAPI from '../api/ttAPI'
import Notification from "../components/Notification";
import { toast } from 'react-toastify'


var UserStateContext = React.createContext();
var UserDispatchContext = React.createContext();


function userReducer(state, action) {
  switch (action.type) {
    /*case "FAKE_LOGIN_SUCCESS":console.log("FAKE_LOGIN_SUCCESS");
      return { ...state, isAuthenticated: true, user_name: '', single_phase_price: 0, three_phase_price: 0,rcd_price: 0, regions: undefined, fakeLogin: true};*/
    case "LOGIN_SUCCESS":console.log("LOGIN_SUCCESS");
      return { ...state, isAuthenticated: true, user_name: '', user_email: '',
                         admin_roles: undefined,
                         single_phase_price: 0,
                         three_phase_price: 0,
                         rcd_price: 0,
                         fire_price: 0,
                         first_aid_price: 0,
                         medical_price: 0,
                         rcd_pb_price: 0,
                         lg_pb_price: 0,
                         lg_m_price: 0,
                         three_phase_rcd_price: 0,
                         microwave_price: 0,
                         non_electrical_price: 0,
                         ladder_price: 0,
                         aed_price: 0,
                         evse_price: 0,
                         hourly_charge: 0,
                         min_charge: 0,
                         local_travel: 0,
                         seventy_hundred_travel: 0,
                         over_100_travel: 0,
                         min_cash_charge: 0,
                         regions: undefined,
                         geo_regions: undefined,fakeLogin: false,
                         disposal_codes: undefined,
                         //services: undefined,
                         testing_scopes: undefined,
                         refund_categories: undefined,
                         refund_types: undefined};
    case "SIGN_OUT_SUCCESS":console.log("SIGN_OUT_SUCCESS");
      return { ...state, isAuthenticated: false, user_name: '', user_email: '',
                         admin_roles: undefined,
                         single_phase_price: 0,
                         three_phase_price: 0,
                         rcd_price: 0,
                         fire_price: 0,
                         first_aid_price: 0,
                         medical_price: 0,
                         rcd_pb_price: 0,
                         lg_pb_price: 0,
                         lg_m_price: 0,
                         three_phase_rcd_price: 0,
                         microwave_price: 0,
                         non_electrical_price: 0,
                         ladder_price: 0,
                         aed_price: 0,
                         evse_price: 0,
                         hourly_charge: 0,
                         min_charge: 0,
                         local_travel: 0,
                         seventy_hundred_travel: 0,
                         over_100_travel: 0,
                         min_cash_charge: 0,
                         regions: undefined,
                         geo_regions: undefined, fakeLogin: false,
                         disposal_codes: undefined,
                         //services: undefined,
                         testing_scopes: undefined,
                         refund_categories: undefined,
                         refund_types: undefined};
    case "LOGIN_FAILURE":console.log('LOGIN_FAILURE');
        return { ...state, isAuthenticated: false, user_name: '', user_email: '',
                           admin_roles: undefined,
                           single_phase_price: 0,
                           three_phase_price: 0,
                           rcd_price: 0,
                           fire_price: 0,
                           first_aid_price: 0,
                           medical_price: 0,
                           rcd_pb_price: 0,
                           lg_pb_price: 0,
                           lg_m_price: 0,
                           three_phase_rcd_price: 0,
                           microwave_price: 0,
                           non_electrical_price: 0,
                           ladder_price: 0,
                           aed_price: 0,
                           evse_price: 0,
                           hourly_charge: 0,
                           min_charge: 0,
                           local_travel: 0,
                           seventy_hundred_travel: 0,
                           over_100_travel: 0,
                           min_cash_charge: 0,
                           regions: undefined,
                           geo_regions: undefined, fakeLogin: false,
                           disposal_codes: undefined,
                           //services: undefined,
                           testing_scopes: undefined,
                           refund_categories: undefined,
                           refund_types: undefined};
    case "USER_INFO_LOADED":console.log("USER_INFO_LOADED");
        return { ...state, isAuthenticated: true,
                           //fakeLogin: false,
                           user_name: localStorage.getItem("user_name"),
                           user_email: localStorage.getItem("user_email"),
                           admin_roles: JSON.parse(localStorage.getItem("admin_roles")),
                           single_phase_price: localStorage.getItem("single_phase_price"),
                           three_phase_price: localStorage.getItem("three_phase_price"),
                           rcd_price: localStorage.getItem("rcd_price"),
                           fire_price: localStorage.getItem("fire_price"),
                           first_aid_price: localStorage.getItem("first_aid_price"),
                           medical_price: localStorage.getItem("medical_price"),
                           rcd_pb_price: localStorage.getItem("rcd_pb_price"),
                           lg_pb_price: localStorage.getItem("lg_pb_price"),
                           lg_m_price: localStorage.getItem("lg_m_price"),
                           three_phase_rcd_price: localStorage.getItem("three_phase_rcd_price"),
                           microwave_price: localStorage.getItem("microwave_price"),
                           non_electrical_price: localStorage.getItem("non_electrical_price"),
                           ladder_price: localStorage.getItem("ladder_price"),
                           aed_price: localStorage.getItem("aed_price"),
                           evse_price: localStorage.getItem("evse_price"),
                           hourly_charge: localStorage.getItem("hourly_charge"),
                           min_charge: localStorage.getItem("min_charge"),
                           local_travel: localStorage.getItem("local_travel"),
                           seventy_hundred_travel: localStorage.getItem("seventy_hundred_travel"),
                           over_100_travel: localStorage.getItem("over_100_travel"),
                           min_cash_charge: localStorage.getItem("min_cash_charge"),
                           regions: JSON.parse(localStorage.getItem("regions")),
                           geo_regions: JSON.parse(localStorage.getItem("geo_regions")),
                           disposal_codes: JSON.parse(localStorage.getItem("disposal_codes")),
                           //services: JSON.parse(localStorage.getItem("services")),
                           testing_scopes: JSON.parse(localStorage.getItem("testing_scopes")),
                           refund_categories: JSON.parse(localStorage.getItem("refund_categories")),
                           refund_types: JSON.parse(localStorage.getItem("refund_types"))};
    case "DEFAULT_PRICING_LOADED":console.log("DEFAULT_PRICING_LOADED");
        return { ...state, isAuthenticated: true,
                           //fakeLogin: false,
                           user_name: localStorage.getItem("user_name"),
                           user_email: localStorage.getItem("user_email"),
                           admin_roles: JSON.parse(localStorage.getItem("admin_roles")),
                           single_phase_price: localStorage.getItem("single_phase_price"),
                           three_phase_price: localStorage.getItem("three_phase_price"),
                           rcd_price: localStorage.getItem("rcd_price"),
                           fire_price: localStorage.getItem("fire_price"),
                           first_aid_price: localStorage.getItem("first_aid_price"),
                           medical_price: localStorage.getItem("medical_price"),
                           rcd_pb_price: localStorage.getItem("rcd_pb_price"),
                           lg_pb_price: localStorage.getItem("lg_pb_price"),
                           lg_m_price: localStorage.getItem("lg_m_price"),
                           three_phase_rcd_price: localStorage.getItem("three_phase_rcd_price"),
                           microwave_price: localStorage.getItem("microwave_price"),
                           non_electrical_price: localStorage.getItem("non_electrical_price"),
                           ladder_price: localStorage.getItem("ladder_price"),
                           aed_price: localStorage.getItem("aed_price"),
                           evse_price: localStorage.getItem("evse_price"),
                           hourly_charge: localStorage.getItem("hourly_charge"),
                           min_charge: localStorage.getItem("min_charge"),
                           local_travel: localStorage.getItem("local_travel"),
                           seventy_hundred_travel: localStorage.getItem("seventy_hundred_travel"),
                           over_100_travel: localStorage.getItem("over_100_travel"),
                           min_cash_charge: localStorage.getItem("min_cash_charge"),
                           regions: JSON.parse(localStorage.getItem("regions")),
                           geo_regions: JSON.parse(localStorage.getItem("geo_regions")),
                           disposal_codes: JSON.parse(localStorage.getItem("disposal_codes")),
                           //services: JSON.parse(localStorage.getItem("services")),
                           testing_scopes: JSON.parse(localStorage.getItem("testing_scopes")),
                           refund_categories: JSON.parse(localStorage.getItem("refund_categories")),
                           refund_types: JSON.parse(localStorage.getItem("refund_types"))};
    case "REGIONS_LOADED":console.log("REGIONS_LOADED");
         return { ...state, isAuthenticated: true,
                            //fakeLogin: false,
                            user_name: localStorage.getItem("user_name"),
                            user_email: localStorage.getItem("user_email"),
                            admin_roles: JSON.parse(localStorage.getItem("admin_roles")),
                            single_phase_price: localStorage.getItem("single_phase_price"),
                            three_phase_price: localStorage.getItem("three_phase_price"),
                            rcd_price: localStorage.getItem("rcd_price"),
                            fire_price: localStorage.getItem("fire_price"),
                            first_aid_price: localStorage.getItem("first_aid_price"),
                            medical_price: localStorage.getItem("medical_price"),
                            rcd_pb_price: localStorage.getItem("rcd_pb_price"),
                            lg_pb_price: localStorage.getItem("lg_pb_price"),
                            lg_m_price: localStorage.getItem("lg_m_price"),
                            three_phase_rcd_price: localStorage.getItem("three_phase_rcd_price"),
                            microwave_price: localStorage.getItem("microwave_price"),
                            non_electrical_price: localStorage.getItem("non_electrical_price"),
                            ladder_price: localStorage.getItem("ladder_price"),
                            aed_price: localStorage.getItem("aed_price"),
                            evse_price: localStorage.getItem("evse_price"),
                            hourly_charge: localStorage.getItem("hourly_charge"),
                            min_charge: localStorage.getItem("min_charge"),
                            local_travel: localStorage.getItem("local_travel"),
                            seventy_hundred_travel: localStorage.getItem("seventy_hundred_travel"),
                            over_100_travel: localStorage.getItem("over_100_travel"),
                            min_cash_charge: localStorage.getItem("min_cash_charge"),
                            regions: JSON.parse(localStorage.getItem("regions")),
                            geo_regions: JSON.parse(localStorage.getItem("geo_regions")),
                            disposal_codes: JSON.parse(localStorage.getItem("disposal_codes")),
                            //services: JSON.parse(localStorage.getItem("services")),
                            testing_scopes: JSON.parse(localStorage.getItem("testing_scopes")),
                            refund_categories: JSON.parse(localStorage.getItem("refund_categories")),
                            refund_types: JSON.parse(localStorage.getItem("refund_types"))};
    case "GEO_REGIONS_LOADED":console.log("GEO_REGIONS_LOADED");
         return { ...state, isAuthenticated: true,
                            //fakeLogin: false,
                            user_name: localStorage.getItem("user_name"),
                            user_email: localStorage.getItem("user_email"),
                            admin_roles: JSON.parse(localStorage.getItem("admin_roles")),
                            single_phase_price: localStorage.getItem("single_phase_price"),
                            three_phase_price: localStorage.getItem("three_phase_price"),
                            rcd_price: localStorage.getItem("rcd_price"),
                            fire_price: localStorage.getItem("fire_price"),
                            first_aid_price: localStorage.getItem("first_aid_price"),
                            medical_price: localStorage.getItem("medical_price"),
                            rcd_pb_price: localStorage.getItem("rcd_pb_price"),
                            lg_pb_price: localStorage.getItem("lg_pb_price"),
                            lg_m_price: localStorage.getItem("lg_m_price"),
                            three_phase_rcd_price: localStorage.getItem("three_phase_rcd_price"),
                            microwave_price: localStorage.getItem("microwave_price"),
                            non_electrical_price: localStorage.getItem("non_electrical_price"),
                            ladder_price: localStorage.getItem("ladder_price"),
                            aed_price: localStorage.getItem("aed_price"),
                            evse_price: localStorage.getItem("evse_price"),
                            hourly_charge: localStorage.getItem("hourly_charge"),
                            min_charge: localStorage.getItem("min_charge"),
                            local_travel: localStorage.getItem("local_travel"),
                            seventy_hundred_travel: localStorage.getItem("seventy_hundred_travel"),
                            over_100_travel: localStorage.getItem("over_100_travel"),
                            min_cash_charge: localStorage.getItem("min_cash_charge"),
                            regions: JSON.parse(localStorage.getItem("regions")),
                            geo_regions: JSON.parse(localStorage.getItem("geo_regions")),
                            disposal_codes: JSON.parse(localStorage.getItem("disposal_codes")),
                            //services: JSON.parse(localStorage.getItem("services")),
                            testing_scopes: JSON.parse(localStorage.getItem("testing_scopes")),
                            refund_categories: JSON.parse(localStorage.getItem("refund_categories")),
                            refund_types: JSON.parse(localStorage.getItem("refund_types"))};
    case "DISPOSAL_CODES_LOADED":console.log("DISPOSAL_CODES_LOADED");
         return { ...state, isAuthenticated: true,
                            //fakeLogin: false,
                            user_name: localStorage.getItem("user_name"),
                            user_email: localStorage.getItem("user_email"),
                            admin_roles: JSON.parse(localStorage.getItem("admin_roles")),
                            single_phase_price: localStorage.getItem("single_phase_price"),
                            three_phase_price: localStorage.getItem("three_phase_price"),
                            rcd_price: localStorage.getItem("rcd_price"),
                            fire_price: localStorage.getItem("fire_price"),
                            first_aid_price: localStorage.getItem("first_aid_price"),
                            medical_price: localStorage.getItem("medical_price"),
                            rcd_pb_price: localStorage.getItem("rcd_pb_price"),
                            lg_pb_price: localStorage.getItem("lg_pb_price"),
                            lg_m_price: localStorage.getItem("lg_m_price"),
                            three_phase_rcd_price: localStorage.getItem("three_phase_rcd_price"),
                            microwave_price: localStorage.getItem("microwave_price"),
                            non_electrical_price: localStorage.getItem("non_electrical_price"),
                            ladder_price: localStorage.getItem("ladder_price"),
                            aed_price: localStorage.getItem("aed_price"),
                            evse_price: localStorage.getItem("evse_price"),
                            hourly_charge: localStorage.getItem("hourly_charge"),
                            min_charge: localStorage.getItem("min_charge"),
                            local_travel: localStorage.getItem("local_travel"),
                            seventy_hundred_travel: localStorage.getItem("seventy_hundred_travel"),
                            over_100_travel: localStorage.getItem("over_100_travel"),
                            min_cash_charge: localStorage.getItem("min_cash_charge"),
                            regions: JSON.parse(localStorage.getItem("regions")),
                            geo_regions: JSON.parse(localStorage.getItem("geo_regions")),
                            disposal_codes: JSON.parse(localStorage.getItem("disposal_codes")),
                            //services: JSON.parse(localStorage.getItem("services")),
                            testing_scopes: JSON.parse(localStorage.getItem("testing_scopes")),
                            refund_categories: JSON.parse(localStorage.getItem("refund_categories")),
                            refund_types: JSON.parse(localStorage.getItem("refund_types"))};

      /*case "SERVICES_LOADED":console.log("SERVICES_LOADED");
           return { ...state, isAuthenticated: true,
                              //fakeLogin: false,
                              user_name: localStorage.getItem("user_name"),
                              admin_roles: JSON.parse(localStorage.getItem("admin_roles")),
                              single_phase_price: localStorage.getItem("single_phase_price"),
                              three_phase_price: localStorage.getItem("three_phase_price"),
                              rcd_price: localStorage.getItem("rcd_price"),
                              fire_price: localStorage.getItem("fire_price"),
                              first_aid_price: localStorage.getItem("first_aid_price"),
                              medical_price: localStorage.getItem("medical_price"),
                              rcd_pb_price: localStorage.getItem("rcd_pb_price"),
                              lg_pb_price: localStorage.getItem("lg_pb_price"),
                              lg_m_price: localStorage.getItem("lg_m_price"),
                              three_phase_rcd_price: localStorage.getItem("three_phase_rcd_price"),
                              microwave_price: localStorage.getItem("microwave_price"),
                              non_electrical_price: localStorage.getItem("non_electrical_price"),
                              ladder_price: localStorage.getItem("ladder_price"),
                              aed_price: localStorage.getItem("aed_price"),
                              evse_price: localStorage.getItem("evse_price"),
                              hourly_charge: localStorage.getItem("hourly_charge"),
                              min_charge: localStorage.getItem("min_charge"),
                              local_travel: localStorage.getItem("local_travel"),
                              seventy_hundred_travel: localStorage.getItem("seventy_hundred_travel"),
                              over_100_travel: localStorage.getItem("over_100_travel"),
                              min_cash_charge: localStorage.getItem("min_cash_charge"),
                              regions: JSON.parse(localStorage.getItem("regions")),
                              geo_regions: JSON.parse(localStorage.getItem("geo_regions")),
                              disposal_codes: JSON.parse(localStorage.getItem("disposal_codes")),
                              //services: JSON.parse(localStorage.getItem("services")),
                              testing_scopes: JSON.parse(localStorage.getItem("testing_scopes"))};*/
    case "TESTING_SCOPES_LOADED":console.log("TESTING_SCOPES_LOADED");
         return { ...state, isAuthenticated: true,
                            //fakeLogin: false,
                            user_name: localStorage.getItem("user_name"),
                            user_email: localStorage.getItem("user_email"),
                            admin_roles: JSON.parse(localStorage.getItem("admin_roles")),
                            single_phase_price: localStorage.getItem("single_phase_price"),
                            three_phase_price: localStorage.getItem("three_phase_price"),
                            rcd_price: localStorage.getItem("rcd_price"),
                            fire_price: localStorage.getItem("fire_price"),
                            first_aid_price: localStorage.getItem("first_aid_price"),
                            medical_price: localStorage.getItem("medical_price"),
                            rcd_pb_price: localStorage.getItem("rcd_pb_price"),
                            lg_pb_price: localStorage.getItem("lg_pb_price"),
                            lg_m_price: localStorage.getItem("lg_m_price"),
                            three_phase_rcd_price: localStorage.getItem("three_phase_rcd_price"),
                            microwave_price: localStorage.getItem("microwave_price"),
                            non_electrical_price: localStorage.getItem("non_electrical_price"),
                            ladder_price: localStorage.getItem("ladder_price"),
                            aed_price: localStorage.getItem("aed_price"),
                            evse_price: localStorage.getItem("evse_price"),
                            hourly_charge: localStorage.getItem("hourly_charge"),
                            min_charge: localStorage.getItem("min_charge"),
                            local_travel: localStorage.getItem("local_travel"),
                            seventy_hundred_travel: localStorage.getItem("seventy_hundred_travel"),
                            over_100_travel: localStorage.getItem("over_100_travel"),
                            min_cash_charge: localStorage.getItem("min_cash_charge"),
                            regions: JSON.parse(localStorage.getItem("regions")),
                            geo_regions: JSON.parse(localStorage.getItem("geo_regions")),
                            disposal_codes: JSON.parse(localStorage.getItem("disposal_codes")),
                            //services: JSON.parse(localStorage.getItem("services")),
                            testing_scopes: JSON.parse(localStorage.getItem("testing_scopes")),
                            refund_categories: JSON.parse(localStorage.getItem("refund_categories")),
                            refund_types: JSON.parse(localStorage.getItem("refund_types"))};
    case "REFUND_CATEGORIES_LOADED":console.log("REFUND_CATEGORIES_LOADED");
         return { ...state, isAuthenticated: true,
                            //fakeLogin: false,
                            user_name: localStorage.getItem("user_name"),
                            user_email: localStorage.getItem("user_email"),
                            admin_roles: JSON.parse(localStorage.getItem("admin_roles")),
                            single_phase_price: localStorage.getItem("single_phase_price"),
                            three_phase_price: localStorage.getItem("three_phase_price"),
                            rcd_price: localStorage.getItem("rcd_price"),
                            fire_price: localStorage.getItem("fire_price"),
                            first_aid_price: localStorage.getItem("first_aid_price"),
                            medical_price: localStorage.getItem("medical_price"),
                            rcd_pb_price: localStorage.getItem("rcd_pb_price"),
                            lg_pb_price: localStorage.getItem("lg_pb_price"),
                            lg_m_price: localStorage.getItem("lg_m_price"),
                            three_phase_rcd_price: localStorage.getItem("three_phase_rcd_price"),
                            microwave_price: localStorage.getItem("microwave_price"),
                            non_electrical_price: localStorage.getItem("non_electrical_price"),
                            ladder_price: localStorage.getItem("ladder_price"),
                            aed_price: localStorage.getItem("aed_price"),
                            evse_price: localStorage.getItem("evse_price"),
                            hourly_charge: localStorage.getItem("hourly_charge"),
                            min_charge: localStorage.getItem("min_charge"),
                            local_travel: localStorage.getItem("local_travel"),
                            seventy_hundred_travel: localStorage.getItem("seventy_hundred_travel"),
                            over_100_travel: localStorage.getItem("over_100_travel"),
                            min_cash_charge: localStorage.getItem("min_cash_charge"),
                            regions: JSON.parse(localStorage.getItem("regions")),
                            geo_regions: JSON.parse(localStorage.getItem("geo_regions")),
                            disposal_codes: JSON.parse(localStorage.getItem("disposal_codes")),
                            //services: JSON.parse(localStorage.getItem("services")),
                            testing_scopes: JSON.parse(localStorage.getItem("testing_scopes")),
                            refund_categories: JSON.parse(localStorage.getItem("refund_categories")),
                            refund_types: JSON.parse(localStorage.getItem("refund_types"))};
  case "REFUND_TYPES_LOADED":console.log("REFUND_TYPES_LOADED");
       return { ...state, isAuthenticated: true,
                          //fakeLogin: false,
                          user_name: localStorage.getItem("user_name"),
                          user_email: localStorage.getItem("user_email"),
                          admin_roles: JSON.parse(localStorage.getItem("admin_roles")),
                          single_phase_price: localStorage.getItem("single_phase_price"),
                          three_phase_price: localStorage.getItem("three_phase_price"),
                          rcd_price: localStorage.getItem("rcd_price"),
                          fire_price: localStorage.getItem("fire_price"),
                          first_aid_price: localStorage.getItem("first_aid_price"),
                          medical_price: localStorage.getItem("medical_price"),
                          rcd_pb_price: localStorage.getItem("rcd_pb_price"),
                          lg_pb_price: localStorage.getItem("lg_pb_price"),
                          lg_m_price: localStorage.getItem("lg_m_price"),
                          three_phase_rcd_price: localStorage.getItem("three_phase_rcd_price"),
                          microwave_price: localStorage.getItem("microwave_price"),
                          non_electrical_price: localStorage.getItem("non_electrical_price"),
                          ladder_price: localStorage.getItem("ladder_price"),
                          aed_price: localStorage.getItem("aed_price"),
                          evse_price: localStorage.getItem("evse_price"),
                          hourly_charge: localStorage.getItem("hourly_charge"),
                          min_charge: localStorage.getItem("min_charge"),
                          local_travel: localStorage.getItem("local_travel"),
                          seventy_hundred_travel: localStorage.getItem("seventy_hundred_travel"),
                          over_100_travel: localStorage.getItem("over_100_travel"),
                          min_cash_charge: localStorage.getItem("min_cash_charge"),
                          regions: JSON.parse(localStorage.getItem("regions")),
                          geo_regions: JSON.parse(localStorage.getItem("geo_regions")),
                          disposal_codes: JSON.parse(localStorage.getItem("disposal_codes")),
                          //services: JSON.parse(localStorage.getItem("services")),
                          testing_scopes: JSON.parse(localStorage.getItem("testing_scopes")),
                          refund_categories: JSON.parse(localStorage.getItem("refund_categories")),
                          refund_types: JSON.parse(localStorage.getItem("refund_types"))};
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function UserProvider({ children }) {
  var [state, dispatch] = React.useReducer(userReducer, {
    isAuthenticated: !!localStorage.getItem("id_token"),
    user_name: localStorage.getItem("user_name"),
    user_email: localStorage.getItem("user_email"),
    admin_roles: localStorage.getItem("admin_roles") === undefined ||
                 localStorage.getItem("admin_roles") === null ?
                 undefined : JSON.parse(localStorage.getItem("admin_roles"))
  });

  return (
    <UserStateContext.Provider value={state}>
      <UserDispatchContext.Provider value={dispatch}>
        {children}
      </UserDispatchContext.Provider>
    </UserStateContext.Provider>
  );
}

function useUserState() {
  var context = React.useContext(UserStateContext);
  if (context === undefined) {
    throw new Error("useUserState must be used within a UserProvider");
  }
  return context;
}

function useUserDispatch() {
  var context = React.useContext(UserDispatchContext);
  if (context === undefined) {
    throw new Error("useUserDispatch must be used within a UserProvider");
  }
  return context;
}

export { UserProvider, useUserState, useUserDispatch, loginUser, signOut,
         getUserInfo, getDefaultPricing, getRegions, getGeoRegions, isUserLoggedIn,
         getDisposalCodes, sendNotification, /*getServices,*/ getTestingScopes,
         getRefundCategories, getRefundTypes };

// ###########################################################

//async function loginUser(dispatch, login, password, history) {
const loginUser = async (dispatch, login, password, history) => {
  if (!!login && !!password) {
    try {
        //var response = await ttAPI.fakeSignIn(login, password);
        var response = await ttAPI.signIn(login, password);

        if (response === null) {
            console.error('Error login');
            //dispatch({ type: "LOGIN_FAILURE" });
            return false;
        }
        else {
          console.log('login_succes');
            dispatch({ type: 'LOGIN_SUCCESS' });
            //dispatch({ type: 'FAKE_LOGIN_SUCCESS' });
            //console.log("set fake login to true");
            history.push('/app/dashboard');
            /*var signInResponse = await ttAPI.signIn(login, password);
            if (signInResponse !== null) {
              console.log("set fake login to false",signInResponse);
                dispatch({ type: 'LOGIN_SUCCESS' });
                var signInResponse = await ttAPI.getUserInfo(login, password);
            }*/

        }
    } catch(error) {
        console.error(error);
        //dispatch({ type: "LOGIN_FAILURE" });
        return false;
    };

  } else {
      //dispatch({ type: "LOGIN_FAILURE" });
      return false;
  }
}

async function signOut(dispatch, history) {
  //setTimeout(() => {
    try {
      await ttAPI.signOut();
      localStorage.removeItem("id_token");
      localStorage.removeItem("user_name");
      localStorage.removeItem("user_email");
      dispatch({ type: "SIGN_OUT_SUCCESS" });
      console.log('signout success');
      history.push("/login");
    } catch (err) {
      console.error(err);
    }

  //}, 2000);


}

/*function getWorkerTimesheets(dispatch, history, setIsLoading, setError) {
  //setTimeout(() => {
    const apiResponse = ttAPI.getWorkerTimesheets('no');

      //redirect to event
      apiResponse.then((message) => {
          console.log("user getWorkerTimesheets fetched", message);
          if (message !== undefined) {
            setError(null);
            setIsLoading(false);
            dispatch({ type: 'LOGIN_SUCCESS' });
            history.push('/app/dashboard');
          }

      })


  //}, 2000);
}*/

function getUserInfo(dispatch, history, setIsLoading, setError) {
  //setTimeout(() => {
    const apiResponse = ttAPI.getUserInfo('no');

      //redirect to event
      apiResponse.then((message) => {
        console.log('getUserInfo', message);
          if (message !== undefined && message !== null) {
            localStorage.setItem('id_token', message.data.id);
            localStorage.setItem('user_name', message.data.name);
            localStorage.setItem('user_email', message.data.email);
            localStorage.setItem('admin_roles', JSON.stringify(message.data.admin_roles));
            dispatch({ type: 'USER_INFO_LOADED'});
          }
          else {
            localStorage.removeItem("id_token");
            localStorage.removeItem("user_name");
            localStorage.removeItem("user_email");
            localStorage.removeItem("admin_roles");
            dispatch({ type: "SIGN_OUT_SUCCESS" });
            history.push("/login");
          }

      })


  //}, 2000);
}

function isUserLoggedIn(dispatch, history, setIsLoading, setError) {
    const apiResponse = ttAPI.getUserInfo('no');

      //redirect to event
      apiResponse.then((response) => {
          if (response === undefined || response === null) {
            localStorage.removeItem("id_token");
            localStorage.removeItem("user_name");
            localStorage.removeItem("admin_roles");
            dispatch({ type: "SIGN_OUT_SUCCESS" });
            history.push("/login");
          }
      })
}

function getDefaultPricing(dispatch, history, setIsLoading, setError) {
    const apiResponse = ttAPI.getDefaultPricing();

      //redirect to event
      apiResponse
        .then((message) => {
          if (message !== undefined) {
            localStorage.setItem('single_phase_price', message.data.single_phase_price);
            localStorage.setItem('three_phase_price', message.data.three_phase_price);
            localStorage.setItem('rcd_price', message.data.rcd_m_price);
            localStorage.setItem('fire_price', message.data.fire_price);
            localStorage.setItem('first_aid_price', message.data.first_aid_price);
            localStorage.setItem('medical_price', message.data.medical_price);
            localStorage.setItem('rcd_pb_price', message.data.rcd_pb_price);
            localStorage.setItem('lg_pb_price', message.data.lg_pb_price);
            localStorage.setItem('lg_m_price', message.data.lg_m_price);
            localStorage.setItem('three_phase_rcd_price', message.data.three_phase_rcd_price);
            localStorage.setItem('microwave_price', message.data.microwave_price);
            localStorage.setItem('non_electrical_price', message.data.non_electrical_price);
            localStorage.setItem('ladder_price', message.data.ladder_price);
            localStorage.setItem('aed_price', message.data.aed_price);
            localStorage.setItem('evse_price', message.data.evse_price);
            localStorage.setItem('hourly_charge', message.data.hourly_charge);
            localStorage.setItem('min_charge', message.data.min_charge);
            localStorage.setItem('local_travel', message.data.local_travel);
            localStorage.setItem('seventy_hundred_travel', message.data.seventy_hundred_travel);
            localStorage.setItem('over_100_travel', message.data.over_100_travel);
            localStorage.setItem('min_cash_charge', message.data.min_cash_charge);
          }
      })


  //}, 2000);
}


function getRegions(dispatch, history, setIsLoading, setError) {
    const apiResponse = ttAPI.getRegions();

      //redirect to event
      apiResponse.then((message) => {
          if (message !== undefined && message !== null && message.length > 0) {
            localStorage.setItem('regions', JSON.stringify(message));
            dispatch({ type: 'REGIONS_LOADED'});
          }
      })
  //}, 2000);
}

function getGeoRegions(dispatch, history, setIsLoading, setError) {
    const apiResponse = ttAPI.getGeoRegions();

      //redirect to event
      apiResponse.then((message) => {
          if (message !== undefined && message !== null && message.length > 0) {
            localStorage.setItem('geo_regions', JSON.stringify(message));
            dispatch({ type: 'GEO_REGIONS_LOADED'});
          }
      })
  //}, 2000);
}

function getDisposalCodes(dispatch, history, setIsLoading, setError) {
    const apiResponse = ttAPI.getDisposalCodes();

      //redirect to event
      apiResponse.then((message) => {
          if (message !== undefined && message !== null && message.length > 0) {
            localStorage.setItem('disposal_codes', JSON.stringify(message));
            dispatch({ type: 'DISPOSAL_CODES_LOADED'});
          }
      })
  //}, 2000);
}

/*function getServices(dispatch, history, setIsLoading, setError) {
    const apiResponse = ttAPI.getServices();

      //redirect to event
      apiResponse.then((message) => {
          if (message !== undefined && message !== null && message.length > 0) {
            localStorage.setItem('services', JSON.stringify(message));
            dispatch({ type: 'SERVICES_LOADED'});
          }
      })
  //}, 2000);
}*/

function getTestingScopes(dispatch, history, setIsLoading, setError) {
    const apiResponse = ttAPI.getTestingScopes();

      //redirect to event
      apiResponse.then((message) => {
          if (message !== undefined && message !== null && message.length > 0) {
            localStorage.setItem('testing_scopes', JSON.stringify(message));
            dispatch({ type: 'TESTING_SCOPES_LOADED'});
          }
      })
  //}, 2000);
}

function getRefundTypes(dispatch, history, setIsLoading, setError) {
    const apiResponse = ttAPI.getRefundTypes();

      //redirect to event
      apiResponse.then((message) => {
          if (message !== undefined && message !== null && message.length > 0) {
            localStorage.setItem('refund_types', JSON.stringify(message));
            dispatch({ type: 'REFUND_TYPES_LOADED'});
          }
      })
  //}, 2000);
}

function getRefundCategories(dispatch, history, setIsLoading, setError) {
    const apiResponse = ttAPI.getRefundCategories();

      //redirect to event
      apiResponse.then((message) => {
          if (message !== undefined && message !== null && message.length > 0) {
            localStorage.setItem('refund_categories', JSON.stringify(message));
            dispatch({ type: 'REFUND_CATEGORIES_LOADED'});
          }
      })
  //}, 2000);
}

function sendNotification(type,message, classes) {
  const componentProps = {
    type: type,
    message:message,
    variant: 'contained',
    color: type
  };
  const options = {
    type: "info",
    position: toast.POSITION.TOP_RIGHT,
    progressClassName: classes.progress,
    className: classes.notification,
    timeOut: 3000,
    autoClose: 5000
  };
  return toast(
    <Notification
      {...componentProps}
      className={classes.notificationComponent}
    />,
    options
  );
}
